import { t } from "../../../i18n";
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { AppBar, Box, IconButton, Toolbar, Tooltip, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { getPortalRoute, portalConfig } from '../../../configs/portal';
import ProfileSection from './ProfileSection';
import ContextSelector from './ContextSelector';
export default function Header({
  desktop,
  drawerOpen,
  onDrawerToggle
}) {
  const {
    pathname
  } = useLocation();
  const page = getPortalRoute(pathname);
  const toggleLabel = drawerOpen ? 'Recolher menu lateral' : 'Abrir menu lateral';
  return <AppBar component="header" position="sticky" elevation={0} sx={{
    bgcolor: 'primary.light',
    color: 'primary.main',
    borderBottom: '1px solid',
    borderColor: 'divider'
  }}>
            <Toolbar sx={{
      minHeight: `${portalConfig.headerHeight}px !important`,
      gap: {
        xs: 1,
        sm: 2
      }
    }}>
                {!desktop && <Tooltip title={t(toggleLabel)}>
                    <IconButton edge="start" aria-label={t(toggleLabel)} aria-controls="portal-sidebar" aria-expanded={drawerOpen} onClick={onDrawerToggle} color="primary">
                        <MenuIcon />
                    </IconButton>
                </Tooltip>}
                <Box sx={{
        flexGrow: 1,
        minWidth: 0
      }}>
                    <Typography variant="h2" component="h1" noWrap sx={{
          color: 'primary.main',
          fontSize: {
            xs: '1.1rem',
            sm: '1.5rem'
          }
        }}>
                        {t(page?.title) || t('Início')}
                    </Typography>
                    <Typography variant="caption" noWrap sx={{
          display: 'block',
          color: 'text.secondary'
        }}>
                        {t(portalConfig.title)}
                    </Typography>
                </Box>
                <ContextSelector />
                <ProfileSection />
            </Toolbar>
        </AppBar>;
}
Header.propTypes = {
  desktop: PropTypes.bool.isRequired,
  drawerOpen: PropTypes.bool.isRequired,
  onDrawerToggle: PropTypes.func.isRequired
};
